import React, { useState } from "react";

import "./helpoptions.scss";
import { useHistory } from "react-router-dom";
import Restart from "../restart/restart";
import InlineFeedback from "../inlinefeedback/inlinefeedback";

const HelpOptions = (props:any) => {

 const histroyAPI = useHistory();
  const eventOptions = [
    {
      text: "Guided Tour",
      id: 1,
    },
    {
      text: "How to subscribe to proactive notifications",
      id: 2,
    },
     {
      text: "Status APIs",
      id: 3,
    },
    {
      text: "Adobe Customer Support",
      id: 4,
    }

  ];
function restart(){
return <div className="help-restart">
    
    <button 
        className="show-more-link restart-workflow back-arrow-button" 
        onClick={props.actionProvider.handleMoreHelp}
        title="Go back"
        aria-label="Go back"
        data-tooltip="Go back"
    >
    </button>

    <button 
        className="show-more-link restart top-arrow-button" 
        onClick={props.actionProvider.handleOptions}
        title="Start from top"
        aria-label="Start from top"
        data-tooltip="Start from top"
    >
    </button>

    <InlineFeedback conversationId={props.conversationId} />
</div>
}

 const [activeIndex, setActiveIndex] = useState(null);
const [ clicked, setIsClicked] = useState(false);
const [selectedOption, setSelectedOption] = useState("");

  const buttonsMarkup = eventOptions.map((option:any,index:any) => (
    <React.Fragment key={option.id}>
      <button 
        onClick={()=>{
          setIsClicked(true);
          setActiveIndex(index);
          setSelectedOption(option.text);

          switch(option.id){
            case 1:
                histroyAPI.push("/nav");
                const elements:any = document.getElementsByClassName('menutext');
                if (elements.length > 0) {
                    elements[0].click(); 
                }
                props.actionProvider.handleCloseBot();
                break;
            case 2:
                    histroyAPI.push('/help/proactivesubscriptions'); break;
            case 3:
                    window.open('https://developer.adobe.com/adobe-status/'); break;
            case 4:
                  window.open('https://experienceleague.adobe.com/home?support-tab=home#support');break;
          }
        }} 
        className={activeIndex === index?"change-buttons":"option-button"}  
        aria-pressed={activeIndex === index}
        tabIndex={0} // Ensure all buttons remain in tab order
      >
        {option.text}
      </button>
    </React.Fragment>
  ));

  return (
    <div className="options-container" role="group" aria-label="Help options">
      {buttonsMarkup}
      {selectedOption && (
        <div aria-live="polite" className="sr-only">
          Selected: {selectedOption}
        </div>
      )}
      {!clicked?<Restart startfromtop={props.actionProvider.handleOptions} showfeedback = {props.actionProvider.showFeedback}/>:<></>}
      {clicked?restart():<></>}
    </div>
  );
};

export default HelpOptions;
